// @flow
import { Subject } from 'rxjs';

type DvrNotificationType =
  | 'timerSet'
  | 'timerSetError'
  | 'timerUpdated'
  | 'timerUpdateError'
  | 'timerSkipped'
  | 'timerRestored'
  | 'timerSkipRestoreError'
  | 'timerDeleted'
  | 'timerDeleteError'
  | 'recordingDeleted'
  | 'offline';

export type DvrNotification = {|
  type: DvrNotificationType,
  title: string,
  startTime?: ?string,
  frequency?: ?string,
  posterUrl?: ?string,
  recordingId?: string,
  seriesId?: number,
|};

export const dvrNotificationsEmitter = new Subject<DvrNotification>();
export const dvrNotifications$ = dvrNotificationsEmitter.asObservable();
